import { useQuery } from '@tanstack/react-query';
import { getProductsStatus } from '../api/productsStatus/getProductsStatus';

export const useGetProductsStatus = (enabled = true) => {
  const { isLoading, data, isRefetching } = useQuery({
    queryKey: ['products-status'],
    queryFn: getProductsStatus,
    enabled,
  });

  return {
    areProductLoading: isLoading,
    areProductsRefetching: isRefetching,
    productsStatus: data,
  };
};
